<ion-header class="ion-no-border">
    <ion-toolbar>

        <ion-buttons slot="start">
            <ion-button (click)="close()">
                <fa-icon [icon]="['far', 'times']" size="lg" [fixedWidth]="true" slot="start"></fa-icon>
            </ion-button>
        </ion-buttons>

        <ion-title>Sell donation</ion-title>

        <ion-buttons *ngIf="donation_campaigns && donation_campaigns.length != 0" slot="end">
            <ion-button (click)="validateInput()">
                <fa-icon [icon]="['far', 'check']" size="lg" [fixedWidth]="true" slot="start"></fa-icon>
            </ion-button>
        </ion-buttons>

    </ion-toolbar>
</ion-header>

<ion-content>

    <ion-grid *ngIf="donation_campaigns && donation_campaigns.length != 0" class="form">
        <ion-row>
            <ion-col>

                <ion-grid class="fieldset">
                    <ion-row>
                        <ion-col>
                            <ion-select okText="OK" interface="alert" [interfaceOptions]="selectOptions" label="Donation campaign" labelPlacement="stacked" fill="outline" [(ngModel)]="donation_campaign_id">
                                <ion-select-option *ngFor="let campaign of donation_campaigns" value="{{campaign.id}}">{{campaign.title}}</ion-select-option>
                            </ion-select>
                        </ion-col>
                    </ion-row>
                    <ion-row>
                        <ion-col>
                            <ion-input #amount_input type="tel" inputmode="decimal" maxlength="10" autocomplete="new-amount" label="Amount" labelPlacement="stacked" fill="outline" [(ngModel)]="amount"></ion-input>
                        </ion-col>
                    </ion-row>
                </ion-grid>

            </ion-col>
        </ion-row>
    </ion-grid>

    <ion-grid *ngIf="donation_campaigns && donation_campaigns.length == 0" class="nothing-found">
        <ion-row class="ion-align-items-center ion-justify-content-center">
            <ion-col>
                <p>
                    <fa-icon [icon]="['fal', 'hand-holding-usd']" size="6x"></fa-icon>
                    <span>No donation campaigns found</span>
                </p>
            </ion-col>
        </ion-row>
    </ion-grid>

</ion-content>